import React from 'react';
import styles from './howItWorks.module.scss';
import { cx } from '@emotion/css';
import { ImageComponent } from '@modules/services/Components';

const SingleQuality = ({ header, url, alt, description }: any) => {
  return (
    <div className={styles.quality_single_item}>
      <div className={styles.quality_image_container}>
        <ImageComponent
          src={url}
          height={'210'}
          alt={alt}
          className={styles.quality_image}
        />
      </div>
      <div className={styles.quality_content}>
        <div>
          {' '}
          <h5 className={cx(styles.quality_header, styles.h5)}>
            {' '}
            {header}{' '}
          </h5>{' '}
        </div>
        <div> {description} </div>
      </div>
    </div>
  );
};
export const HowItWorksView = () => {
  const qualities = [
    {
      image: '/images/about-us/how_it_works/book_online.png',
      alt: 'Book image',
      header: 'Book Online',
      description: (
        <p className={cx(styles.quality_description, styles.p)}>
          {' '}
          Schedule your service in minutes through our easy booking sytem{' '}
        </p>
      ),
    },
    {
      image: '/images/about-us/how_it_works/utility_van.png',
      alt: 'Man Relax image',
      header: 'Job Done Right',
      description: (
        <p className={cx(styles.quality_description, styles.p)}>
          {' '}
          Sit back while we handle the rest and keep you updated{' '}
        </p>
      ),
    },
    {
      image: '/images/about-us/how_it_works/man_relaxing.png',
      alt: 'Truck image',
      header: 'We Show Up Ready',
      description: (
        <p className={cx(styles.quality_description, styles.p)}>
          {' '}
          Our qualified tradespeople arrive on time and ready to work
        </p>
      ),
    },
  ];
  return (
    <section className={styles.about_us}>
      <div className={styles.root}>
        <div className={styles.about_us_card_block}>
          <div className={styles.container}>
            <div className={styles.inner_section}>
              <div className={styles.heading_wrapers}>
                <h3 className={cx(styles.site_title, styles.h3)}>
                  How Does it Work
                </h3>
                <div className={cx(styles.qualities_container, styles.root)}>
                  {qualities.map((quality, index) => {
                    return (
                      <SingleQuality
                        key={index}
                        header={quality.header}
                        url={quality.image}
                        alt={quality.alt}
                        description={quality.description}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
